<div>
    <app-content-container [content_template]="page_content"
                           [is_loading]="is_loading"
                           [loading_text]="loading_text" [custom_class]="'no-padding'"></app-content-container>
</div>
<ng-template #page_content>
    <div class="padding">
        <div class="card card-1 padding table-wrapper" *ngIf="!is_loading && LapTimes">
            <app-fb-forms-table [storeObj]="LapTimes"
                                [edit_allowed]="false"
                                [storeExtObj]="custom_obj"
                                (row_click)="rowSelected($event)"
                                (add_click)="addClicked()"
                                [stateKey]="'lap-times-overview'"
                                [show_add]="can_add"
                                [show_delete]="is_admin"
                                [title]="'Lap Times'"
            >
            </app-fb-forms-table>
        </div>
    </div>
</ng-template>
<ng-template #select_caption_tpl let-element="element" let-column="column">
    {{element.tmp.caption[column.id]}}
</ng-template>
